import { Typography } from "@mui/material";
import { useState } from "react";
import { SectionContent } from "../../screens/my-profile/SectionContent";
import { SectionHeader } from "../../screens/my-profile/SectionHeader";
import { Section, SubSection } from "../StructureElements/Section";
import { StrucRow } from "../StructureElements/StrucRow";
import { SectionHeaderTypography } from "../Typographies/SectionHeaderTypography";
import VATField from "./VATField";

interface VATSectionProps {
  description?: string;
  value: number;
  onChange?: (value: number) => void;
}
export default function VATSection({
  description,
  value,
  onChange,
}: VATSectionProps) {
  const [open, setOpen] = useState(false);
  return (
    <Section>
      <SectionHeader
        isCloseable
        initialState={open}
        onToggle={(open) => setOpen(open)}
      >
        <SectionHeaderTypography>VAT Settings</SectionHeaderTypography>
      </SectionHeader>
      <SectionContent close={!open} overflowYHidden={false}>
        <StrucRow>
          <SubSection className={"space-y-2"}>
            {description && (
              <Typography className="mb-6 mt-[-16px]">{description}</Typography>
            )}
            <div className={"flex items-center space-x-1.5 pl-1"}>
              <VATField onChange={onChange} value={value} />
            </div>
          </SubSection>
        </StrucRow>
      </SectionContent>
    </Section>
  );
}
